export default __webpack_public_path__ + "static/media/essay-topic.b37b79fd.pdf";